// AuthCallback — processes session_id from URL fragment after OAuth.
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    // Process synchronously at start to avoid StrictMode double-run
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const r = await fetch(`${API}/api/auth/session`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!r.ok) throw new Error("session exchange failed");
        const u = await r.json();
        // Fallback para Safari ITP (borra cookies httpOnly entre sesiones).
        // Guardamos el token también en localStorage y lo enviamos por header.
        if (u.session_token) {
          try { localStorage.setItem("session_token", u.session_token); } catch {}
        }
        setUser({ user_id: u.user_id, email: u.email, name: u.name, picture: u.picture });
        // clear hash and go to /viajes
        window.history.replaceState(null, "", "/viajes");
        navigate("/viajes", { replace: true, state: { user: u } });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="container-app pt-20 text-center">
      <p className="text-sm text-[hsl(var(--muted))]">Entrando…</p>
    </div>
  );
}
